// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2lTaE","item":"PaymentsMobile_item__3new7","label":"PaymentsMobile_label__32KfP","amount":"PaymentsMobile_amount__3sj3l"};